import React, {Component} from "react";
import FullWidthLayout from "./FullWidthLayout";
import "./AuthLayout.css";

class AuthLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            workspace: this.props.workspace || this.getWorkspaceFromData()
        };
    }

    getWorkspaceFromData() {
        // Try to get site data from various sources
        try {
            // Check if site data is passed via props
            if (this.props.workspace) return this.props.workspace;

            // Check if there's a data_site element with site info
            const workspaceDetailElement = document.getElementById('data_workspace');
            if (workspaceDetailElement) {
                const workspace = JSON.parse(workspaceDetailElement.textContent);
                return workspace || null;
            }

            return null;
        } catch (error) {
            console.warn('Could not load workspace data:', error);
            return null;
        }
    }

    renderLogo(align = 'center') {
        const {workspace} = this.state;
        const alignClass = align === 'left' ? 'text-start' : 'text-center';

        return (
            <div className={`${alignClass} mb-4`}>
                <a href="/" className="navbar-brand navbar-brand-autodark">
                    {workspace && workspace.avatar ? (
                        <img
                            src={`/${workspace.avatar}`}
                            alt={workspace.name || "iProfitSocial"}
                            className="navbar-brand-image auth-layout-logo-image"
                        />
                    ) : (
                        <img
                            src="/images/logo.svg"
                            alt="iProfitSocial"
                            className="navbar-brand-image auth-layout-logo-image"
                            onError={(e) => {
                                // Fallback to PNG if SVG doesn't exist
                                e.target.src = "/images/logo.png";
                            }}
                        />
                    )}
                </a>
            </div>
        );
    }

    render() {
        // Allow disabling split-screen layout via prop (for backwards compatibility)
        const useSplitLayout = this.props.splitLayout !== false;
        const illustrationImage = this.props.illustrationImage || '/images/onboarding/2.png';

        if (!useSplitLayout) {
            // Legacy centered layout for backwards compatibility
            return (
                <FullWidthLayout
                    showMessages={true}
                    pageClass={"page-center h-100"}
                    {...this.props}
                >
                    <div className="container container-tight py-4">
                        {this.renderLogo()}
                        <div className="card card-md">
                            <div className="card-body">
                                {this.props.children}
                            </div>
                        </div>
                        <div className="text-center text-secondary mt-3">
                            Copyright © {new Date().getFullYear()} {process.env.MIX_APP_NAME || 'iProfit'}. All rights
                            reserved.
                        </div>
                    </div>
                </FullWidthLayout>
            );
        }

        // New split-screen layout
        return (
            <FullWidthLayout 
                showMessages={this.props.showMessages !== false} 
                pageClass="h-100"
                {...this.props}
            >
                <div className="container-fluid h-100 p-0">
                    <div className="row g-0 h-100">
                        {/* Left Column - Auth Form */}
                        <div className="col-lg-6 auth-layout-form-column d-flex flex-column bg-white">
                            <div className="auth-layout-form-container mx-auto w-100">
                                {this.renderLogo('left')}
                            </div>
                            <div className="d-flex align-items-center justify-content-center flex-grow-1">
                                <div className="w-100 auth-layout-form-container">
                                    {this.props.children}
                                    {this.props.showCopyright !== false && (
                                        <div className="text-center mt-4">
                                            <span className="text-secondary auth-layout-copyright">
                                                Copyright © {new Date().getFullYear()} iprofitsocial. All rights reserved.
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Right Column - Dashboard Illustration */}
                        <div className="col-lg-6 d-none d-lg-flex auth-layout-illustration-column">
                            {this.props.dashboardComponent ? (
                                <>
                                    <div className="auth-layout-dashboard-container">
                                        {this.props.dashboardComponent}
                                    </div>
                                    {this.props.illustrationText && (
                                        <div className="auth-layout-illustration-overlay">
                                            {this.props.illustrationText}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <img 
                                        src={illustrationImage}
                                        alt="Dashboard Preview"
                                        className="auth-layout-illustration-image"
                                        onError={(e) => {
                                            // Fallback if image doesn't load
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                    {this.props.illustrationText && (
                                        <div className="auth-layout-illustration-overlay">
                                            {this.props.illustrationText}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </FullWidthLayout>
        );
    }
}

export default AuthLayout;
